import "./ProductDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import ProductDetailsViewComponent from "./product-details-view/ProductDetailsViewComponent";
import ProductDetailsEditComponent from "./product-details-edit/ProductDetailsEditComponent";

interface ProductDetailsViewEditComponentProps {
    productDetails: any;
    onUpdateProductDetails: Function;
    onModeChange:Function;
    canEdit: boolean;
}

const ProductDetailsViewEditComponent = (props: ProductDetailsViewEditComponentProps) => {
    const {productDetails, onUpdateProductDetails,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [productCompleteDetails, setProductCompleteDetails] = useState<any>(undefined);

    const handleProductDetailsUpdate = useCallback((updatedProductDetails: any) => {
        onUpdateProductDetails(updatedProductDetails);
        setMode("view");
    }, [onUpdateProductDetails]);

    const handleProductDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (productDetails) {
            setProductCompleteDetails(productDetails);
        }
    }, [productDetails]);

    useEffect(()=>{
        onModeChange(mode)
    },[mode,onModeChange]);

    return (
        <div className={'product-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <ProductDetailsViewComponent
                    productDetails={productCompleteDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" &&
                <ProductDetailsEditComponent productDetails={productCompleteDetails}
                                                    facilityId={productDetails.id}
                                                    onUpdateComplete={handleProductDetailsUpdate}
                                                    onEditCancel={handleProductDetailsEditCancel}
                />
            }
        </div>
    );

};

export default ProductDetailsViewEditComponent;
